import { useEffect } from "react";

export default function TickerFijo() {
  useEffect(() => {
    // Solo carga el script en producción para evitar errores en localhost
    if (process.env.NODE_ENV !== "production") return;

    const container = document.getElementById("tv-ticker");
    if (!container) return;

    // Limpiamos por si acaso
    container.innerHTML = "";

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;

    script.textContent = JSON.stringify({
      symbols: [
        { proName: "BINANCE:BTCUSDT", title: "BTC" },
        { proName: "BINANCE:ETHUSDT", title: "ETH" },
        { proName: "OANDA:XAUUSD", title: "GOLD" },
        { proName: "OANDA:XAGUSD", title: "SILVER" },
        { proName: "OANDA:SPX500USD", title: "S&P 500" },
        { proName: "OANDA:NAS100USD", title: "NASDAQ" },
        { proName: "FX_IDC:USDARS", title: "USD/ARS" },
        { proName: "OANDA:BRENT", title: "BRENT" }
      ],
      showSymbolLogo: true,
      colorTheme: "dark",
      isTransparent: false,
      displayMode: "adaptive",
      locale: "es"
    });

    container.appendChild(script);

    // Limpieza al desmontar
    return () => {
      container.innerHTML = "";
    };
  }, []);

  return (
    <div
      id="tv-ticker"
      className="fixed bottom-0 left-0 w-full z-50 border-t border-slate-800 bg-slate-900"
      style={{ height: "60px" }}
    />
  );
}
